import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { StepSection } from 'pages/AppointmentsReserve/components/ui/StepSection';

interface AppointmentsCalendarSectionProps {
  className?: string;
}

export const AppointmentsCalendarSection = ({
  className,
  children,
}: React.PropsWithChildren<AppointmentsCalendarSectionProps>): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <StepSection
      title={t('AppointmentsReserve.Steps.session.dateTime.title')}
      className={className}
      containerClassName="h-full w-full"
    >
      {children}
    </StepSection>
  );
};
